/**
 * Attributes to prevent password managers from autofilling identity data
 * - data-1p-ignore: 1Password
 * - data-lpignore: LastPass
 * - data-form-type: Dashlane
 * - data-bwignore: Bitwarden
 */
export const noAutofillProps = {
  autoComplete: "off",
  "data-1p-ignore": true,
  "data-lpignore": "true",
  "data-form-type": "other",
  "data-bwignore": true,
} as const

/**
 * Generates a random hex color
 */
export function randomColor(): string {
  const letters = '0123456789abcdef'
  let color = '#'
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return color
}
